import { PageHero } from '../components/sections/PageHero';
import { AdmisionProcess } from '../components/sections/AdmisionProcess';
import { AdmisionForm } from '../components/sections/AdmisionForm';
import { AdmisionFaqs } from '../components/sections/AdmisionFaqs';
import { AdmisionUrgencyCta } from '../components/sections/AdmisionUrgencyCta';

export const InformacionAdmisionPage = () => (
  <div className="pt-20" data-testid="admisiones-page">
    <PageHero
      title="Información de Admisión"
      subtitle="Comienza el viaje educativo de tu hijo con nosotros."
    />
    <AdmisionProcess />
    <AdmisionForm />
    <AdmisionFaqs />
    <AdmisionUrgencyCta />
  </div>
);
